import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  capturePageview,
  identifyFromStoredSession,
} from './posthog';

/**
 * Fires pathname-only $pageview on SPA navigations and restores identify() after reload.
 */
export default function PosthogAnalytics() {
  const location = useLocation();

  useEffect(() => {
    identifyFromStoredSession();
  }, []);

  useEffect(() => {
    capturePageview(location.pathname);
  }, [location.pathname]);

  return null;
}
